import { createContext } from "react";

export const OnboardingChecklistContext = createContext(null);
